import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Column, Row } from "../../../../../common/columns";
import Line from "../../../../../common/line/Line";
import { ThemeContext } from "../../../../../common/theme/ThemeContext";
import { format } from "date-fns";
function JournalAttachments({ attachments }) {
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);

  return (
    <>
      {attachments.attachments.map((attachment, index) => (
        <div key={index}>
          <Row>
            <Column>
              <span className={"has-text-weight-bold"}>
                {t("requests.allRequests.journal.attachments.label")}
              </span>
            </Column>
            <Column>
              <span className={"has-text-weight-bold"}>
                {t("requests.allRequests.journal.attachments.submissionDate")}
              </span>
            </Column>
          </Row>
          <Row>
            <Column> {`${attachment.label}`}</Column>
            <Column>
              {attachment.submissionDate
                ? format(new Date(attachment.submissionDate), "dd.MM.yyyy")
                : ""}
            </Column>
          </Row>
          <Line height={2} color={theme.lineColor} />
          <br />
        </div>
      ))}
    </>
  );
}
export default JournalAttachments;
